import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const StyledCarousel = styled(Carousel)`
  width: 100%;

  & .carousel-slider {
    overflow: visible !important;
  }
  & .control-dots {
    bottom: -35px !important;
    padding-inline: 10px !important;
  }
  & .slide-content {
    width: 100%;
    max-width: 100%;
    height: 100%;
  }
`;

const SlideButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.3);
  color: ${({ theme }) => theme.colors.white};
  height: 50px;
  width: 50px;
  border-radius: 100%;
  font-size: 2rem;
  z-index: 99;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;

  //Show on iPad Pro
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    display: none;
  }

  &.prev {
    left: 1rem;
    svg {
      margin-right: 3px;
    }
  }
  &.next {
    right: 1rem;
    svg {
      margin-left: 3px;
    }
  }
`;
const SlideIndicator = styled.li`
  height: 4px;
  border-radius: 10px;
  background: #dbdbdb;
  display: inline-block;
  @media (min-width: 416px) {
    display: none;
  }
`;

export default function SuperHero({ children, activateAutoplay }) {
  const slideCount = React.Children.toArray(children).length;
  const [play, setPlay] = useState(activateAutoplay);
  return (
    <StyledCarousel
      showStatus={false}
      infiniteLoop={true}
      showThumbs={false}
      autoPlay={play}
      interval={8000}
      onClickItem={
        activateAutoplay ? () => setPlay((prev) => !prev) : undefined
      }
      renderArrowPrev={(onClickHandler, hasPrev, label) =>
        hasPrev && (
          <SlideButton onClick={onClickHandler} title={label} className="prev">
            <FontAwesomeIcon icon={faChevronLeft} size="sm" />
          </SlideButton>
        )
      }
      renderArrowNext={(onClickHandler, hasNext, label) =>
        hasNext && (
          <SlideButton onClick={onClickHandler} title={label} className="next">
            <FontAwesomeIcon icon={faChevronRight} size="sm" />
          </SlideButton>
        )
      }
      renderIndicator={(onClickHandler, isSelected, index, label) => {
        if (isSelected) {
          return (
            <SlideIndicator
              style={{
                background: "#343434",
                width: `calc(100%/${slideCount})`,
              }}
              aria-label={`Selected: ${label} ${index + 1}`}
              title={`Selected: ${label} ${index + 1}`}
            />
          );
        }
        return (
          <SlideIndicator
            style={{ width: `calc(100%/${slideCount})` }}
            onClick={onClickHandler}
            onKeyDown={onClickHandler}
            value={index}
            key={index}
            role="button"
            tabIndex={0}
            title={`${label} ${index + 1}`}
            aria-label={`${label} ${index + 1}`}
          />
        );
      }}
    >
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          className: `slide-content ${child.props.className ?? ""}`.trim(),
        })
      )}
    </StyledCarousel>
  );
}

SuperHero.propTypes = {
  children: PropTypes.node,
  activateAutoplay: PropTypes.bool,
};
